export const BOOKS = [
  {
    id: "slumbering-monk",
    number: "01",
    title: "The Slumbering Monk",
    author: "Nicholas K F Matte",
    tag: "Meditation",
    genre: "Meditative Fiction",
    description:
      "Manu is a tired old soul, weary of his practice and often in confusion. His visions bring forth great experiences of his past and future lives. And finally, after a consultation with his guru, he is led to his ultimate goal.",
    pull: "Past lives. Future lives. One final awakening.",
    link: "https://www.amazon.ca/Slumbering-Monk-Nicholas-K-Matte-ebook/dp/B07ZBLFQ32",
    image:
      "https://images.unsplash.com/photo-1574610758891-5b809b6e6e2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBtb3VudGFpbiUyMHNpbGhvdWV0dGUlMjBuaWdodHxlbnwwfHx8fDE3ODcxNzc4NzF8MA&ixlib=rb-4.1.0&q=85",
    gradient: "linear-gradient(155deg, #1e1b4b 0%, #0f0d24 45%, #0C0A09 100%)",
    accent: "#8b8cf9",
  },
  {
    id: "poems-and-haiku",
    number: "02",
    title: "Poems and Haiku",
    author: "Nicholas K F Matte",
    tag: "Poetry",
    genre: "Poetry Collection",
    description:
      "Poetry inspired by the great Buddhist statues of China and Japan. Haiku honouring remarkable individuals from history. Verses drawn from everyday life. A book for everyone who still believes seventeen syllables can hold the whole world.",
    pull: "Seventeen syllables. The whole world.",
    link: "https://www.amazon.ca/Poems-Haiku-Nicholas-K-Matte/dp/1999195523",
    image:
      "https://images.unsplash.com/photo-1608501821300-4f99e58bba77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGRhcmslMjBpbmslMjBmbG93fGVufDB8fHx8MTc4NzE3Nzg3MXww&ixlib=rb-4.1.0&q=85",
    gradient: "linear-gradient(155deg, #134e4a 0%, #0a2725 45%, #0C0A09 100%)",
    accent: "#5eead4",
  },
  {
    id: "short-stories",
    number: "03",
    title: "Short Stories",
    author: "Nicholas K F Matte",
    tag: "Action",
    genre: "Short Fiction",
    description:
      "A brilliant collection — fresh, imaginative and quite comical at times. It takes the reader around the world with scenarios in Israel, Italy, Japan and many other locales. Gratifying and very entertaining.",
    pull: "Israel. Italy. Japan. One restless imagination.",
    link: "https://www.amazon.ca/Short-Stories-Mr-Nicholas-Matte/dp/1999195531",
    image:
      "https://images.unsplash.com/photo-1521225753516-46438a76f25a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHx2aW50YWdlJTIwdHlwZXdyaXRlciUyMGRhcmslMjBzdHVkaW8lMjBsaWdodGluZ3xlbnwwfHx8fDE3ODcxNzc4ODR8MA&ixlib=rb-4.1.0&q=85",
    gradient: "linear-gradient(155deg, #7c2d12 0%, #31130a 45%, #0C0A09 100%)",
    accent: "#fb923c",
  },
];

export const PUBLISHER_IMAGE =
  "https://images.unsplash.com/photo-1472803828399-39d4ac53c6e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwY29uY3JldGUlMjBhcmNoaXRlY3R1cmUlMjBkYXJrfGVufDB8fHx8MTc4NzE3Nzg3MXww&ixlib=rb-4.1.0&q=85";
